import ExchangeReport from '../components/ExchangeReport';

function SellReport() {
  return <ExchangeReport type="sell" />;
}

export default SellReport;
